import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import SampleHome from "./SampleHome";

export default function SampleList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Samples" parent="Home" title="List of Samples" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <SampleHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
